import { render } from "./express.vue?vue&type=template&id=0bdc6fac"
import script from "./express.vue?vue&type=script&lang=ts"
export * from "./express.vue?vue&type=script&lang=ts"

import "./express.vue?vue&type=style&index=0&id=0bdc6fac&lang=scss"
script.render = render

export default script